import * as Yup from 'yup'

const CancelMedicationSchema = Yup.object({
  cancellationReason: Yup.string().label('Cancellation Reason').notRequired().nullable().default(''),
})

export type CancelMedicationFormValues = Yup.InferType<typeof CancelMedicationSchema>

export default CancelMedicationSchema
